import PropTypes from "prop-types";
import Avatar from "@shared/v2/Avatar";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const AgentTextsRow = ({ agent }) => (
  <TR>
    <TD>
      <a className="tw-flex tw-items-center tw-gap-[8px]" href={`/people/${agent.user_path}`}>
        <Avatar size="medium" src={agent.avatar} alt={agent.agent} />
        {agent.agent}
      </a>
    </TD>
    <TD>{agent.text_report_agent_total_lead_count}</TD>
    <TD>{agent.text_report_lead_text_count}</TD>
    <TD>{agent.text_report_non_lead_text_count}</TD>
    <TD>{agent.text_report_total_texts}</TD>
    <TD>{agent.text_report_total_texts_recd}</TD>
    <TD>{agent.text_report_total_text_count}</TD>
  </TR>
);

AgentTextsRow.propTypes = {
  agent: PropTypes.shape().isRequired,
};

export default AgentTextsRow;
